/**
 * Mask an email for display on the returning-user login, e.g.
 * tim@gmail.com -> t****m@g****l.com. Hides the full address (and its length)
 * while staying recognizable. The real address is submitted behind the scenes.
 */
export function maskEmail(email: string): string {
  const at = email.indexOf('@')
  if (at < 1) return email
  const local = email.slice(0, at)
  const domain = email.slice(at + 1)
  const dot = domain.lastIndexOf('.')
  const name = dot > 0 ? domain.slice(0, dot) : domain
  const tld = dot > 0 ? domain.slice(dot) : ''
  const mask = (s: string) => (s.length <= 1 ? s : `${s[0]}****${s[s.length - 1]}`)
  return `${mask(local)}@${mask(name)}${tld}`
}
